import {
    NinchatActionType,
    NinchatDeleteMessageAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const deleteMessage = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatDeleteMessageAction}`,
    async (arg: NinchatActionParams<NinchatDeleteMessageAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatDeleteMessageAction

        try {
            return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
